module Meevo.Plugins.Client {

    import Client = Meevo.Model.Client;

    export class NamePhoneSearchStrategy extends ClientSearchStrategyBase implements IClientSearchStrategy {

        get valid(): boolean {
            const phones: Meevo.Model.Phone[] = (this.model.phoneNumbers || <Meevo.Model.Phone[]>[])
                .filter(row => row.number && row.number.length > 0);

            return phones.length > 0
                && (this.model.firstName || '').length > 0
                && (this.model.lastName || '').length > 0
                ;
        }

        search(options?: any): ng.IPromise<Model.Client[]> {
            if (!this.valid) {
                return;
            }

            return this.$q.all(this.model.phoneNumbers
                .filter(phone => phone && phone.number && phone.number.length > 0)
                .map(phone => {
                    const criteria = {
                        firstName: this.model.firstName,
                        lastName: this.model.lastName,
                        phoneFull: phone.number,
                        isForceGlobal: !this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.localClientSearchOnly
                    };

                    return this.dataService.getListPaged('client', {criteria})
                })).then((...results) => {
                    return _
                        .chain(results)
                        .flatten()
                        .uniq(false, (res: Client) => res.id)
                        .value();
            });
        }

        showWarning(modalService: Meevo.Components.Modal.IModalService, clients: Model.Client[]): ng.IPromise<any> {
            var customOptions: Meevo.Components.Modal.ILocalOptions = {
                showCancelButton: true,
                cancelButtonContentKey: "LABEL_NO_GO_TO_EXISTING_PROFILE"
            };

            return modalService.confirm("WARNING_DUPLICATE_CLIENT_PHONE",
                                        Meevo.Components.Modal.ModalTranslationModes.Translate,
                                        false,
                                        customOptions,
                                        true)
                .then((response: boolean) => {
                    if (!response) {
                        // if user clicks on negative action
                        return clients[0].id;
                    }
                });

        }
    }
}
